// removed by extract-text-webpack-plugin
module.exports = {"confirmText":"styles__confirmText____M-m4"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/CancelScheduleModal/styles.css
// module id = 2886
// module chunks = 0